<template>
  <div class="msgPush">
    <div class="breadcrumb">
      消息推送
      <el-button type="primary" class="right_f" @click="newMsg(0)"
        >新增</el-button
      >
    </div>

    <div class="search">
      <el-select v-model="msgType">
        <el-option label="全部类型" value="-1"></el-option>
        <el-option label="类型一" value="1"></el-option>
        <el-option label="类型二" value="2"></el-option>
        <el-option label="类型三" value="3"></el-option>
      </el-select>
      <el-select v-model="pushRange">
        <el-option label="全部学校" value="1"></el-option>
        <el-option label="部分学校" value="2"></el-option>
        <el-option label="部分学生" value="3"></el-option>
      </el-select>
      <el-select v-model="msgStatus">
        <el-option label="全部状态" value="-1"></el-option>
        <el-option label="已推送" value="1"></el-option>
        <el-option label="草稿" value="0"></el-option>
      </el-select>
      <el-button @click="getMsgList">筛选</el-button>
    </div>

    <div class="com-list">
      <el-table :data="list" style="overflow-x: auto">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="消息ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="msgPurpose"
          label="消息用途"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="msgType"
          label="消息类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="pushRange"
          label="推送范围"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="msgStatus"
          label="状态"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sendTime"
          label="推送时间"
          align="center"
        ></el-table-column>
        <el-table-column inline-template label="操作" width="200">
          <span>
            <el-button class="option" type="text" @click="toDetail(row)"
              >详情</el-button
            >
            <el-button
              class="option"
              type="text"
              v-if="row.msgStatus == '草稿'"
              @click="newMsg(1, row)"
              >编辑</el-button
            >
            <el-button
              class="option"
              type="text"
              v-if="row.msgStatus == '草稿'"
              @click="pushMsg(row)"
              >推送</el-button
            >
            <el-button
              class="option"
              type="text"
              v-if="row.msgStatus == '草稿'"
              @click="deleteMsg(row)"
              >删除</el-button
            >
          </span>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        v-show="this.totalCount > 0"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :current-page="currentPage"
        :total="totalCount"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      msgType: this.$util.getUrlParam("msgType") || "-1",
      msgStatus: this.$util.getUrlParam("msgStatus") || "-1",
      pushRange: this.$util.getUrlParam("pushRange") || "1",
      list: [],
      currentPage: 1,
      totalCount: 0,
    };
  },
  mounted() {
    if (this.$util.getUrlParam("currentPage")) {
      this.currentPage = this.$util.getUrlParam("currentPage") * 1;
      setTimeout(() => {
        this.getMsgList();
      }, 100);
    } else {
      this.getMsgList();
    }
  },
  methods: {
    newMsg(type, row) {
      let params = {
        msgType: this.msgType,
        msgStatus: this.msgStatus,
        pushRange: this.pushRange,
        currentPage: this.currentPage,
      };
      if (type == 1) {
        //编辑
        params.id = row.id;
      }
      this.$util.refreshTo("/#/message/newMsg", params);
    },
    //获取消息列表
    getMsgList() {
      let url = this.$util.domain + "/adminapi/v1/secretary/list";
      this.$http({
        url,
        method: "GET",
        params: {
          msgStatus: this.msgStatus,
          msgType: this.msgType,
          pushRange: this.pushRange,
          pageSize: 10,
          pageIndex: this.currentPage,
        },
      }).then((response) => {
        this.list = [];
        this.totalCount = 0;
        if (response.data.error == 10000) {
          let list = response.data.data.secretaryDraftDigestList;
          this.totalCount = response.data.data.totalPage * 10;

          if (list && list.length) {
            list.forEach((item) => {
              item.createTime = new Date(item.createTime).format("yyyy.MM.dd");
              item.sendTime = item.sendTime
                ? new Date(item.sendTime).format("yyyy.MM.dd")
                : "";
              item.msgStatus = item.msgStatus == 1 ? "已推送" : "草稿";
              if (item.msgType == 1) {
                item.msgType = "类型一";
              } else if (item.msgType == 2) {
                item.msgType = "类型二";
              } else if (item.msgType == 3) {
                item.msgType = "类型三";
              }

              if (item.pushRange == 1) {
                item.pushRange = "全部学校";
              } else if (item.pushRange == 2) {
                item.pushRange = "部分学校";
              } else if (item.pushRange == 3) {
                item.pushRange = "部分学生";
              }
            });
            this.list = list;
          }
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    //推送消息
    pushMsg(row) {
      this.$confirm("您是否确定要推送这条消息？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let url = this.$util.domain + "/adminapi/v1/secretary/send";
          this.$http({
            url,
            method: "GET",
            params: {
              msgId: row.id,
            },
          }).then((response) => {
            if (response.data.error == 10000) {
              this.$util.successMsg("推送成功", "温馨提示");
              this.getMsgList();
            } else {
              this.$util.errorMsg(response.data.message);
            }
          });
        })
        .catch(() => {
          //取消推送的回调
        });
    },
    //详情
    toDetail(row) {
      let params = {
        id: row.id,
        msgType: this.msgType,
        msgStatus: this.msgStatus,
        pushRange: this.pushRange,
        currentPage: this.currentPage,
      };
      this.$util.refreshTo("/#/message/msgDetail", params);
    },
    //删除推送
    deleteMsg(row) {
      this.$confirm("您是否确定要删除这条消息？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let url = this.$util.domain + "/adminapi/v1/secretary/delete";
          this.$http({
            url,
            method: "GET",
            params: {
              msgId: row.id,
            },
          }).then((response) => {
            if (response.data.error == 10000) {
              this.$util.successMsg("删除推送", "温馨提示");
              this.getMsgList();
            } else {
              this.$util.errorMsg(response.data.message);
            }
          });
        })
        .catch(() => {
          //取消删除的回调
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMsgList();
    },
  },
};
</script>
<style>
.msgPush {
  min-height: calc(100vh - 60px);
}

.msgPush .el-select {
  display: inline-block;
}

.msgPush .el-input {
  display: inline-block;
  width: auto;
}

.msgPush .el-button {
  display: inline-block;
}

.msgPush .el-button + .el-button {
  margin-left: 0;
}

.msgPush .search {
  margin-left: 30px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// msgPush.vue?19f361ef